import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, Route, Switch, useRouteMatch } from 'react-router-dom';
import { RequestNewLog } from '../../../api/log-requests';
import { RequestDeleteStock, RequestGetStocks } from '../../../api/stock-requests';
import DataTable from '../../../components/system/DataTable';
import DebugButton from '../../../components/system/DebugButton';
import Loading from '../../../components/system/loading';
import { useAuth } from '../../../context/auth';
import { ENotificationType, useNotifications } from '../../../context/notifications';
import { ELogType, ESeverity } from '../../../interface/log';
import { IStock } from '../../../interface/stock';
import AdminStock from './Admin.Stock';


const AdminStocksPge = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [things, setThings] = useState<IStock[]>();
    let match = useRouteMatch();
    const { addNotification } = useNotifications()!;
    const { auth } = useAuth()!;


    useEffect(() => {
        window.addEventListener('unload', logOnUnload)
        return () => {
            window.removeEventListener('unload', logOnUnload)
            logOnUnload()
        }
    }, [])
    //log unload page?
    const logOnUnload = async () => {
        return RequestNewLog(undefined, {
            type: ELogType.reactUse,
            requestId: '',
            sessionId: '',
            userId: '',
            payload: '',
            severity: ESeverity.Trivial,
            text: 'react stores onunload'
        });
    }
    // eslint-disable-next-line
    {/*<!-- OPTIONAL 1 -->*/ }

    // eslint-disable-next-line
    {/*<!-- OPTIONAL END -->*/ }



    const mounted = useRef(false);
    useEffect(() => {
        try {
            if (mounted.current === false) {
                mounted.current = true
                // eslint-disable-next-line
                {/*<!-- OPTIONAL 2 -->*/ }
                RequestGetStocks(addNotification).then(thing => {
                    //   console.log(stores)
                    setThings(thing);
                    setLoading(false);
                })
                // eslint-disable-next-line
                {/*<!-- OPTIONAL END -->*/ }
            }
        } catch (ex) {
            RequestNewLog(addNotification, { type: ELogType.reactException, text: 'React try catch exception - Stocks - useEffect', payload: ex, requestId: '', sessionId: '', userId: '', severity: ESeverity.Issue })
            addNotification && addNotification('Error', 'Caught Error', ENotificationType.Warning);
        }

    }, [loading, addNotification]);

    const onDelete = (value: IStock) => {
        try {

            const conf = window.confirm("Delete?");
            if (conf) {
                setLoading(true);
                RequestDeleteStock(addNotification, value).then(res => {
                    //  console.log(res);
                    let thingsD: IStock[] = [];
                    if (things) {
                        thingsD = [...things];
                    }
                    const index = thingsD.findIndex(thing => thing._id === value._id);
                    thingsD.splice(index, 1);

                    setThings(thingsD);
                    setLoading(false);
                    addNotification && addNotification('Success', 'Stock Deleted!', ENotificationType.Primary);
                });
            }
        } catch (ex) {
            RequestNewLog(addNotification, { type: ELogType.reactException, text: 'React try catch exception - Stocks - onDelete', payload: ex, requestId: '', sessionId: '', userId: '', severity: ESeverity.Issue })
            addNotification && addNotification('Error', 'Caught Error', ENotificationType.Warning);
        }
    }



    return (<>
        {loading === true && <Loading />}
        {things && <div className="col-12">
            <h2>Stocks Admin</h2>
            <p className="bg-primary">ok this bit is a list of every stock item used for details on said item shouldn't really be used in the end more for checking things</p>

            <Helmet>
                <title>Stocks / Admin / {auth.metaData && auth.metaData.SYSTEM_NAME && auth.metaData.SYSTEM_NAME}</title>
            </Helmet>

            {/*<!-- OPTIONAL 3 -->*/}
            <DataTable <IStock>

                colHeadings={[
                    {
                        name: "Store", field: "storeId", r: (value, index) => {
                            return <Link to={`/admin/stores/${value.store && value.store.id}`}>{value.store && value.store.id}</Link>;
                        }, sortable: true, queryable: true,
                    },
                    {
                        name: "Product", field: "productId", r: (value, index) => {
                            return <Link to={`/admin/products/${value.product && value.product.id}`}>{value.product && value.product.partNumber}</Link>;
                        }, sortable: true
                    },

                    { name: "Quantity", field: "qty", sortable: false },
                    {
                        name: "Actions", field: "id", r: (value: any, index) => {
                            return <div className="btn-group">
                                <DebugButton data={value} />
                                <Link className="btn btn-primary" to={`${match.url}/${value.id}`}>View</Link>
                                {/* <button className="btn btn-danger" onClick={(ev: React.MouseEvent) => {
                                    ev.preventDefault();
                                    onDelete(value);
                                }}>Delete</button> */}
                            </div>;
                        }, sortable: false
                    },

                ]}

                data={things}
            />

            {/*<!-- OPTIONAL END -->*/}
        </div>}
    </>
    );
};
const AdminStocks = () => {
    let match = useRouteMatch();
    return (<>
        <Switch>
            <Route path={`${match.path}/:id`}>
                <AdminStock />
            </Route>
            <Route path={`${match.path}`} exact>
                <AdminStocksPge />
            </Route>

        </Switch>
    </>
    );
}

export default AdminStocks;